import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface ContactSubmission {
  id?: string;
  name: string;
  email: string;
  phone: string;
  project_type: string;
  location: string;
  client_type: string;
  budget_range: string;
  message: string;
  created_at?: string;
}

export async function submitContactForm(data: Omit<ContactSubmission, 'id' | 'created_at'>) {
  const { data: result, error } = await supabase
    .from('contact_submissions')
    .insert([data])
    .select()
    .maybeSingle();

  if (error) throw error;
  return result;
}
